'use client'

import { Stepper, TStepProps, TStepState } from 'components/Stepper'
import { useTranslations } from 'next-intl'

import { TGeneratorStep } from '../generatorTypes'
import { useCurrGeneratorStep } from '../hooks'

export const CreateModeGeneratorStepper = ({
	className,
	isChangeTypeMode,
}: {
	className?: string
	isChangeTypeMode: boolean
}) => {
	const currStep = useCurrGeneratorStep()

	const t = useTranslations()

	const STEP_TO_STEP_STATE_LIST = {
		type: ['current', 'uncompleted', 'uncompleted'],
		content: ['completed', 'current', 'uncompleted'],
		design: ['completed', 'completed', 'current'],
	} as const satisfies Record<TGeneratorStep, TStepState[]>

	const stepList: Omit<TStepProps, 'index'>[] = [
		{
			state: STEP_TO_STEP_STATE_LIST[currStep][0],
			labelMobile: t('generator__stepper__step1_mobile'),
			labelDesktop: t(
				isChangeTypeMode
					? 'generator__stepper__step1_desktop__change'
					: 'generator__stepper__step1_desktop',
			),
		},
		{
			state: STEP_TO_STEP_STATE_LIST[currStep][1],
			labelMobile: t('generator__stepper__step2_mobile'),
			labelDesktop: isChangeTypeMode
				? t('generator__stepper__edit_mode__step2')
				: t('generator__stepper__step2_desktop'),
		},
		{
			state: STEP_TO_STEP_STATE_LIST[currStep][2],
			labelMobile: t('generator__stepper__step3_mobile'),
			labelDesktop: isChangeTypeMode
				? t('generator__stepper__change_type_mode__step3')
				: t('generator__stepper__step3_desktop'),
		},
	]

	return <Stepper key={currStep} stepList={stepList} className={className} />
}

export const EditModeGeneratorStepper = ({
	className,
}: {
	className?: string
}) => {
	const currStep = useCurrGeneratorStep()

	const t = useTranslations()

	const stepList: {
		labelMobile: string
		labelDesktop: string
		state: TStepState
	}[] = [
		{
			state: currStep === 'content' ? 'current' : 'completed',
			labelMobile: t('generator__stepper__edit_mode__step2'),
			labelDesktop: t('generator__stepper__edit_mode__step2'),
		},
		{
			state: currStep === 'design' ? 'current' : 'uncompleted',
			labelMobile: t('generator__stepper__edit_mode__step3'),
			labelDesktop: t('generator__stepper__edit_mode__step3'),
		},
	]

	return <Stepper key={currStep} stepList={stepList} className={className} />
}
